import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Tabs Redux States
import {
  GET_TABS,
  GET_TAB,
  CREATE_TAB,
  EDIT_TAB,
  DELETE_TAB,
} from "./actionTypes";
import {
  setTabs,
  apiError,
  setTab,
  createTabSuccess,
  editTabSuccess,
  deleteTabSuccess,
} from "./actions";

//Include Both Helper File with needed methods
import axios from "axios";

function* getTabs({ payload: { page, qnt, value, type, isForm, isInformationTab = false } }) {
  try {
    const response = yield call(
      axios.get,
      `/tab?${
        (page ? `page=${page}` : "") +
        (qnt ? `&qtd=${qnt}` : "") +
        (value && type ? `&value=${value}` : "") +
        (type && value ? `&type=${type}` : "") +
        (isForm ? `&form=${isForm}` : "") +
        (`&isInformationTab=${isInformationTab}`)
      }`
    );
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.data
    ) {
      yield put(setTabs(response.data.data, qnt));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          //TODO: remover esta verificação quando o backend enviar array vazio com status 200 quando nao ha objetos
          if (error.response.data && typeof error.response.data === "object") {
            message = error.response.data.message;
          } else {
            message = "Sorry! the page you are looking for could not be found";
          }
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

function* createTab({ payload: { newTabValues } }) {
  try {
    const response = yield call(axios.post, `/tab`, newTabValues);
    if (response.status >= 200 || response.status <= 299) {
      let message = response.data.message;
      yield put(createTabSuccess(message));
    } else {
      throw response.data;
    }
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

function* getTab({ payload: { idTab, isForm } }) {
  try {
    const response = yield call(
      axios.get,
      `/tab?${
        (idTab ? `id=${idTab}` : "") + (isForm ? `&form=${isForm}` : "")
      }`,
      {}
    );
    if ((response.status >= 200 || response.status <= 299) && response.data) {
      yield put(setTab(response.data));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
function* editTab({ payload: { idTab, newTabValues } }) {
  try {
    const response = yield call(
      axios.patch,
      `/tab?${idTab ? `id=${idTab}` : ""}`,
      newTabValues
    );
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.message
    ) {
      let message = response.data.message;
      yield put(editTabSuccess(message));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
function* deleteTab({ payload: { idTab } }) {
  try {
    const response = yield call(
      axios.delete,
      `/tab${idTab ? `?id=${idTab}` : ""}`
    );
    if (response.status >= 200 || response.status <= 299) {
      let message = response.data.message ? response.data.message : "";
      yield put(deleteTabSuccess(message));
    } else {
      throw response.data;
    }
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
export function* watchTab() {
  yield takeEvery(GET_TABS, getTabs);
}
export function* watchGetTab() {
  yield takeEvery(GET_TAB, getTab);
}
export function* watchCreateTab() {
  yield takeEvery(CREATE_TAB, createTab);
}
export function* watchEditTab() {
  yield takeEvery(EDIT_TAB, editTab);
}
export function* watchDeleteTab() {
  yield takeEvery(DELETE_TAB, deleteTab);
}
function* authSaga() {
  yield all([
    fork(watchTab),
    fork(watchGetTab),
    fork(watchCreateTab),
    fork(watchEditTab),
    fork(watchDeleteTab),
  ]);
}

export default authSaga;
